export enum DeviceErrorClassEnum {
    error = 0,
    warning = 1,
    information = 2,
}
